import { Icon, IconName } from "react-frontier";
import { NavLink, useLocation } from "react-router-dom";

interface SidebarItemProps{
   text: string,
   to?: string,
   search?: string,
   extra?: any,
   iconName: IconName,
   badge?: any,
   onClick?: ()=>void,
}

var SidebarItem=(props: SidebarItemProps)=>{
   var location = useLocation();
   var content=<div className="btn">
      <Icon name={props.iconName} />
      <div className="text">{props.text}</div>
      {!!props.badge&&(
         <div className="badge">{props.badge}</div>
      )}
      {!!props.extra && typeof props.extra !== 'boolean' && (
         <div className="extra-content">{props.extra}</div>
      )}
   </div>

   if(props.to){
      var isActive = location.pathname === props.to && location.search === (props.search || '');
      return <NavLink 
         className="item" 
         to={{
            pathname: props.to,
            search: props.search
         }}
         replace
         style={{
            backgroundColor: isActive ? "rgba(0,0,0,0.05)" : '' 
         }} >
         {content}
      </NavLink>
   }else{
      return <div className="item" onClick={props.onClick}>
         {content}
      </div>
   }
}

export default SidebarItem;